import { render } from "./RevenueForecast.vue?vue&type=template&id=64c9adc2&scoped=true"
import script from "./RevenueForecast.vue?vue&type=script&lang=js"
export * from "./RevenueForecast.vue?vue&type=script&lang=js"

import "./RevenueForecast.vue?vue&type=style&index=0&id=64c9adc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c9adc2"]])

export default __exports__